/* eslint-disable space-before-blocks */
import { SET_LOB_PRODUCT_TOGGLE } from "constants-lib/actionTypes"
import { lobType } from "constants-lib/common"

const initialState = {
  productLob: lobType.COMMERCIAL,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_LOB_PRODUCT_TOGGLE:
      return {
        ...state,
        productLob: action.payload,
      }

    default:
      return state
  }
}
